import React, { useEffect, useRef, useState } from "react";
import DropdownButton from "./DropdownButton";
import DropdownWrapper from "./DropdownWrapper";

const accessibleGoldenDropdown = (WrappedComponent) => {
  return function EnhancedComponent({
    heading,
    selectedMember,
    ReportMenuContent,
    reportsMenuOpen,
    setReportsMenuOpen,
    showArrow,
    showPopup,
    isDisabled,
    disabledPopup,
    popUpId = "",
    popUpRole = "",
    ariaHasPopUp = "",
    ariaControls = "",
    OPTIONS,
    buttonProps,
    popupClassName = {
      open: "",
      close: "",
      wrapperClass: "",
      dropDownContainerClass,
      popupMenuClass,
    },
    btnClass = "",
    accessibilityValues,
    onCustomClose = () => {},
    setCustomIndex,
    ...rest
  }) {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [focusedIndex, setFocusedIndex] = useState(0);

    const buttonRef = useRef(null);
    const wrapperRef = useRef(null);
    const optionRefs = useRef([]);

    const selectedTextRef = useRef(null);

    const [isTextOverflowing, setIsTextOverflowing] = useState(false);

    useEffect(() => {
      if (selectedTextRef?.current) {
        setIsTextOverflowing(
          selectedTextRef?.current?.scrollWidth >
            selectedTextRef?.current?.clientWidth
            ? true
            : false,
        );
      }
    }, [heading, selectedTextRef?.curren]);

    const closeDropdown = (focusButton = true) => {
      setIsOpen(false);

      if (focusButton) {
        buttonRef.current?.focus();
      }
    };

    const openDropdown = (index) => {
      if (!setCustomIndex) {
        setFocusedIndex(index);
      } else {
        const { selectedIndex, focusedIndex } = setCustomIndex({ index });
        setSelectedIndex(selectedIndex);
        setFocusedIndex(focusedIndex);
      }
      setIsOpen(true);
    };

    useEffect(() => {
      if (isOpen) {
        optionRefs.current[focusedIndex]?.focus();
      }
    }, [isOpen, focusedIndex]);

    // Outside click
    useEffect(() => {
      const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeDropdown(false);
        }
      };

      document.addEventListener("mousedown", handleClickOutside);

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    const selectOption = (index) => {
      setSelectedIndex(index);
      closeDropdown(true);
    };

    const handleButtonKeyDown = (e) => {
      switch (e.key) {
        case "Enter":
        case " ":
          e.preventDefault();
          openDropdown(selectedIndex);
          break;

        case "ArrowDown":
          e.preventDefault();
          openDropdown(0);
          break;

        case "ArrowUp":
          e.preventDefault();
          openDropdown(OPTIONS.length - 1);
          break;

        default:
          break;
      }
    };

    const handleOptionKeyDown = (e, index) => {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();
          setFocusedIndex((prev) =>
            prev === OPTIONS.length - 1 ? 0 : prev + 1,
          );
          break;

        case "ArrowUp":
          e.preventDefault();
          setFocusedIndex((prev) =>
            prev === 0 ? OPTIONS.length - 1 : prev - 1,
          );
          break;

        case "Enter":
        case " ":
          e.preventDefault();
          selectOption(index);
          break;

        case "Escape":
          e.preventDefault();
          closeDropdown(true);
          break;

        case "Tab":
          setIsOpen(false); // close popup
          return; // allow browser's normal tabbing

        default:
          break;
      }
    };
    return (
      <>
        <DropdownWrapper
          isDisabled={isDisabled}
          popupClassName={popupClassName}
          heading={heading}
          showPopup={showPopup}
          isTextOverflowing={isTextOverflowing}
          ref={selectedTextRef}
        >
          <>
            {/* <div ref={ref} style={{ position: "relative" }}>
              <PopupMenu
                MenuContent={ReportMenuContent}
                open={reportsMenuOpen}
                setOpen={setReportsMenuOpen}
                position={position}
                showArrow={showArrow}
                disabledPopup={disabledPopup}
                popupMenuClass={popupMenuClass}
                id={popUpId}
                role={popUpRole}
                ariaHasPopUp={ariaHasPopUp}
                ariaExpanded={reportsMenuOpen}
                ariaControls={ariaControls}
              >
                <div className={`${dropDownContainerClass || ""} dropdown_btn`}>
                  {isTextOverflowing ? (
                    <Marquee speed={24} pauseOnHover gradient={false}>
                      <p className="selected_text marquee-text">{heading}</p>
                    </Marquee>
                  ) : (
                    <p
                      className="selected_text"
                      ref={selectedTextRef}
                      style={{
                        width: "calc(100% - 23px)",
                        overflowX: "hidden",
                      }}
                    >
                      {heading}
                    </p>
                  )}
                  {!disabledPopup ? (
                    <div
                      className={`golden_down_arrow ${
                        reportsMenuOpen ? "is-active" : ""
                      }`}
                    >
                      <GoldenArrow />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </PopupMenu>
            </div> */}

            <div style={{ position: "relative" }}>
              <div ref={wrapperRef} className={popupClassName.wrapperClass}>
                <button
                  ref={buttonRef}
                  type="button"
                  aria-haspopup={accessibilityValues.ariaHasPopUp}
                  aria-expanded={isOpen}
                  aria-controls={accessibilityValues.ariaControls}
                  onClick={() =>
                    isOpen ? closeDropdown(false) : openDropdown(selectedIndex)
                  }
                  onKeyDown={handleButtonKeyDown}
                  className={`children buttonWrapper ${btnClass}`}
                  styale={{ width: "fit-content" }}
                >
                  <>
                    <DropdownButton
                      heading={heading}
                      dropDownContainerClass={
                        popupClassName.dropDownContainerClass
                      }
                      isTextOverflowing={isTextOverflowing}
                      disabledPopup={disabledPopup}
                      reportsMenuOpen={isOpen}
                      ref={selectedTextRef}
                    />
                  </>
                </button>

                {isOpen && (
                  <WrappedComponent
                    {...rest}
                    popupClassName={popupClassName}
                    OPTIONS={OPTIONS}
                    isOpen={isOpen}
                    focusedIndex={focusedIndex}
                    handleOptionKeyDown={(e, index) =>
                      handleOptionKeyDown(e, index)
                    }
                    selectOption={(index) => {
                      selectOption(index);
                    }}
                    optionRefs={optionRefs}
                    accessibilityValues={accessibilityValues}
                    selectedIndex={selectedIndex}
                  />
                )}
              </div>
            </div>
          </>
        </DropdownWrapper>
      </>
    );
  };
};

export default accessibleGoldenDropdown;
